<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card styleClass="very-compact-card p-3">
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="regulation.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>
        </div>
      </p-card>

      <p-card styleClass="very-compact-card mt-3 p-3">
        <h3 class="required-field">ЕСЛИ</h3>

        <div *ngIf="expressionsArrayError">
          <small class="p-error">
            {{ expressionsArrayError }}
          </small>
        </div>

        <ng-container *ngFor="let expression of regulation.expressions; let index = index">
          <ng-container *ngIf="expression.type === BankStatementRuleExpressionTypeEnum.CONDITION">
            <div class="p-fluid">
              <div
                *ngIf="getExpressionError(index)"
                class="mb-2">
                <small class="p-error">
                  {{ getExpressionError(index) }}
                </small>
              </div>
              <div class="field">
                <div class="flex align-items-center gap-3">
                  <crm-bank-statement-rule-condition-kind-single-select
                    [(kind)]="expression.condition.kind"
                    appendTo="body"
                    class="flex-grow-1"></crm-bank-statement-rule-condition-kind-single-select>

                  <i
                    class="pi pi-times text-red-500 hover:text-red-400 cursor-pointer"
                    style="font-size: 1.5rem"
                    (click)="deleteExpression(expression, index)"></i>
                </div>
              </div>
              <div class="field">
                <crm-bank-statement-rule-condition-type-single-select
                  styleClass="w-9rem"
                  appendTo="body"
                  [(type)]="expression.condition.type"></crm-bank-statement-rule-condition-type-single-select>
              </div>
              <div class="field">
                <ng-container [ngSwitch]="expression.condition.kind">
                  <ng-container *ngSwitchCase="BankStatementRuleConditionKindEnum.COMPANY">
                    <crm-company-single-select
                      [(selectedCompany)]="expression.condition.company"
                      [isError]="$any(errors?.expressions?.[index]?.condition?.company)"
                      appendTo="body"
                      styleClass="max-w-full"></crm-company-single-select>
                    <small
                      *ngIf="errors?.expressions?.[index]?.condition?.company"
                      class="p-error">
                      {{ errors.expressions[index].condition.company | join }}
                    </small>
                  </ng-container>
                  <ng-container *ngSwitchCase="BankStatementRuleConditionKindEnum.COMPANY_BANK_DETAILS">
                    <crm-bank-details-auto-complete
                      [(selectedBankDetail)]="expression.condition.companyBankDetails"
                      [bankDetails]="bankDetails"
                      [isError]="$any(errors?.expressions?.[index]?.condition?.companyBankDetails)"
                      (bankDetailsSearch)="searchBankDetails($event)"
                      appendTo="body"></crm-bank-details-auto-complete>
                    <small
                      *ngIf="errors?.expressions?.[index]?.condition?.companyBankDetails"
                      class="p-error">
                      {{ errors.expressions[index].condition.companyBankDetails | join }}
                    </small>
                  </ng-container>
                  <ng-container *ngSwitchCase="BankStatementRuleConditionKindEnum.CONTRAGENT">
                    <crm-contragent-auto-complete
                      [(selectedContragent)]="expression.condition.contragent"
                      [isError]="$any(errors?.expressions?.[index]?.condition?.contragent)"
                      [customSearch]="false"
                      appendTo="body"></crm-contragent-auto-complete>
                    <small
                      *ngIf="errors?.expressions?.[index]?.condition?.contragent"
                      class="p-error">
                      {{ errors.expressions[index].condition.contragent | join }}
                    </small>
                  </ng-container>
                  <ng-container *ngSwitchCase="BankStatementRuleConditionKindEnum.DATE">
                    <crm-datepicker
                      [(value)]="expression.condition.date"
                      appendTo="body"></crm-datepicker>
                    <small
                      *ngIf="errors?.expressions?.[index]?.condition?.date"
                      class="p-error">
                      {{ errors.expressions[index].condition.date | join }}
                    </small>
                  </ng-container>
                  <ng-container *ngSwitchCase="BankStatementRuleConditionKindEnum.AMOUNT">
                    <p-inputNumber [(ngModel)]="expression.condition.amount"></p-inputNumber>
                    <small
                      *ngIf="errors?.expressions?.[index]?.condition?.amount"
                      class="p-error">
                      {{ errors.expressions[index].condition.amount | join }}
                    </small>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <p-skeleton height="3rem"></p-skeleton>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="expression.type === BankStatementRuleExpressionTypeEnum.OPERATOR">
            <div class="p-fluid">
              <div class="field">
                <crm-bank-statement-rule-joint-type-single-select
                  [(type)]="expression.operator"
                  appendTo="body"
                  styleClass="w-7rem"></crm-bank-statement-rule-joint-type-single-select>
                <small
                  *ngIf="errors?.expressions?.[index]?.operator"
                  class="p-error">
                  {{ errors.expressions[index].operator | join }}
                </small>
              </div>
            </div>
          </ng-container>

          <p-divider
            *ngIf="index !== regulation.expressions.length - 1"
            styleClass="border-1 border-300"></p-divider>
        </ng-container>

        <crm-button
          label="Добавить условие"
          icon="pi pi-plus"
          styleClass="p-button-success p-button-text mt-2"
          (onClick)="addExpression()"></crm-button>
      </p-card>

      <p-card styleClass="very-compact-card mt-3 p-3">
        <h3 class="required-field">ТО</h3>

        <p-selectButton
          [options]="excludeOptions"
          [(ngModel)]="regulation.exclude"
          styleClass="shadow-none"></p-selectButton>
        <div *ngIf="errors?.exclude">
          <small class="p-error">
            {{ errors.exclude | join }}
          </small>
        </div>

        <div
          *ngIf="!regulation.exclude"
          class="p-fluid mt-3">
          <div class="field">
            <label class="font-medium">Бизнес единица</label>
            <crm-unit-single-select
              [(selectedUnit)]="regulation.unit"
              [isError]="$any(errors?.unit)"
              [showClear]="true"
              appendTo="body"></crm-unit-single-select>
            <small
              *ngIf="errors?.unit"
              class="p-error">
              {{ errors.unit | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Бюджетная статья</label>
            <crm-direction-single-select
              [directions]="directions"
              [(selectedDirection)]="regulation.direction"
              [styleClass]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
              [showClear]="true"
              appendTo="body"></crm-direction-single-select>
            <small
              *ngIf="errors?.direction"
              class="p-error">
              {{ errors.direction | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Филиал</label>
            <crm-filial-single-select
              [(selectedFilial)]="regulation.filial"
              [isError]="$any(errors?.filial)"
              [showClear]="true"
              appendTo="body"></crm-filial-single-select>
            <small
              *ngIf="errors?.filial"
              class="p-error">
              {{ errors.filial | join }}
            </small>
          </div>

          <div
            *ngIf="accessService.finance.dealRights.canReadDeal"
            class="field">
            <label class="font-medium">Сделка</label>
            <crm-deal-auto-complete
              [(selectedDeal)]="regulation.deal"
              [isError]="$any(errors?.deal)"
              [showClear]="true"
              appendTo="body"></crm-deal-auto-complete>
            <small
              *ngIf="errors?.deal"
              class="p-error">
              {{ errors.deal | join }}
            </small>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div
    *ngIf="(form$ | async)?.canWrite"
    class="grid mt-3">
    <div class="col-12 flex flex-wrap justify-content-between">
      <div>
        <crm-button
          [label]="saveButtonLabel"
          styleClass="p-button-success mr-2"
          (onClick)="saveRegulation()"></crm-button>
      </div>
      <crm-button
        *ngIf="(form$ | async)?.isShowDelete"
        [label]="'Удалить'"
        styleClass="p-button-danger p-button-text"
        (onClick)="deleteRegulation()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
